import React, { useEffect } from "react";
import { navigate } from "gatsby";
import AccountBar from "../components/TWComponents/AccountBar";
import AccountTab from "../components/TWComponents/AccountTab";
import { isLoggedIn } from "../services/Auth";

import Async from "components/Async/Async";

import { useDispatch } from "react-redux";

import { useAuth0 } from "@auth0/auth0-react";
import { setUserData } from "../data/setUserData";
import { getLang } from "../state/reducers/langSession";
import { saveState } from "../state/utils/localStorage";
import { useSelector } from "react-redux";
import { Spin } from "antd";

const isAuth0Enabled = process.env.GATSBY_ENABLE_AUTH0 === "true";

const Member = ({
  props,
  editProfileUrl,
  location,
  loginUrl,
  Memberlang,
  MemberProfilelang,
  MissingPointLang,
  FeedbackLang,
  ChangePasswordLang,
  MyVoucherlang,
  TransactionHistorylang,
  MyReservationlang,
  openWidgetAction,
}) => {
  const userData = setUserData();
  const language = getLang();

  const {
    isLoading: isAuth0AuthenticationLoading,
    user: auth0User,
    isAuthenticated,
  } = useAuth0();

  const dispatch = useDispatch();

  useEffect(() => {
    if (isLoggedIn() === false && !isAuth0Enabled) {
      navigate(loginUrl);
    }
  }, [isLoggedIn, dispatch]);

  const guestInformation = useSelector(
    (store) => store.guestInformation.member.data
  );

  const guest = guestInformation?.guest;

  return (
    <Async
      isLoading={isAuth0AuthenticationLoading}
      onSuccess={() => (
        <>
          <div className="container container--1000 tablet--hide tw-mt-10">
            <h2 className="tw-text-center tw-font-[350px] tw-font-gotham tw-leading-7 tw-tracking-[0.28px]">
              {Memberlang.title_welcome}
              {guestInformation ? guest?.firstName : userData?.firstname}
            </h2>
            <p className="tw-text-[16px] tw-leading-6 tw-text-center tw-tracking-[0.15px]">
              {Memberlang.information}
            </p>
          </div>

          <div className="md:tw-flex md:tw-flex-row md:tw-justify-center tw-gap-x-6 md:tw-mx-[90px] md:tw-mt-[24px]">
            <AccountBar
              langData={Memberlang}
              userData={userData}
              locale={language}
              location={location}
              openWidgetAction={openWidgetAction}
            />
            <div className="md:tw-w-[860px] ">
              <AccountTab
                location={location}
                pageContext={props.pageContext}
                langData={Memberlang}
                MemberProfilelang={MemberProfilelang}
                editProfileUrl={editProfileUrl}
                ChangePasswordLang={ChangePasswordLang}
                MissingPointLang={MissingPointLang}
                FeedbackLang={FeedbackLang}
                MyVoucherlang={MyVoucherlang}
                TransactionHistorylang={TransactionHistorylang}
                MyReservationlang={MyReservationlang}
                guestId={userData.guest_id}
                openWidgetAction={openWidgetAction}
                language={language}
              />
            </div>
          </div>
        </>
      )}></Async>
  );
};

const MemberAuthGuard = (props) => {
  const { isLoading, isAuthenticated, loginWithRedirect } = useAuth0();
  const language = getLang();

  useEffect(() => {
    if (isLoading || isAuthenticated) return;
    const returnPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    saveState("redirectUrl", returnPath);
    loginWithRedirect({
      authorizationParams: {
        redirect_uri:
          language === "en"
            ? `${window.location.origin}/callback`
            : `${window.location.origin}/${language}/callback`,
      },
      appState: {
        target: "redirectUrl",
      },
    });
  }, [isLoading, isAuthenticated, loginWithRedirect, language]);

  if (isLoading) {
    return (
      <div style={{ minHeight: "50vh", display: "grid", placeItems: "center" }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return null;
  }
  return <Member {...props} />;
};

export default isAuth0Enabled ? MemberAuthGuard : Member;
